import React from 'react'

import ReupHeader from 'components/shared/ReupHeader'
import Campers from './Campers'
import Parents from './Parents'
import EmergencyContacts from './EmergencyContacts'
import PickupPeople from './PickupPeople'
import Preferences from './Preferences'
import RegisterButton from './RegisterButton'

const Overview = props => {
  const { account, season, setModal } = props
  const { registrationStatus, preferences } = account || {}
  const {
    reupRequired,
    validCampers,
    validParents,
    validEmergencyContacts,
    validPickupPeople
  } = registrationStatus || {}

  const { onlineOnly = true } = preferences || {}

  return (
    <>
      {reupRequired && <ReupHeader season={season} />}

      <Campers
        title={validCampers ? 'Campers' : 'Confirm Campers'}
        buttonText='Add a new camper'
        buttonRoute='/campers/new'
        subheaderText={
          validCampers
            ? null
            : `Please confirm the details for any camper attending in ${season.year} to proceed with registration; you do not need to buy days for all campers now.`
        }
        account={account}
        setModal={setModal}
        reupRequired={reupRequired}
        editable
      />
      <Parents
        title={
          validParents ? 'Parents / Guardians' : 'Confirm Parents / Guardians'
        }
        buttonText='Add a new parent / guardian'
        buttonRoute='/parents/new'
        subheaderText={
          validParents
            ? null
            : `To confirm parent and guardian details for ${season.year}, click the "confirm" or "remove" button for each person listed below.`
        }
        account={account}
        setModal={setModal}
        reupRequired={reupRequired}
        editable
      />

      {!onlineOnly && (
        <EmergencyContacts
          title={
            validEmergencyContacts
              ? 'Emergency Contacts'
              : 'Confirm Emergency Contacts'
          }
          buttonText='Add a new emergency contact'
          buttonRoute='/emergency_contacts/new'
          subheaderText={
            validEmergencyContacts
              ? null
              : `To confirm or update emergency contacts for ${season.year}, click the "confirm" or "remove" button for each person listed below.`
          }
          account={account}
          setModal={setModal}
          reupRequired={reupRequired}
          editable
        />
      )}

      {!onlineOnly && (
        <PickupPeople
          title={
            validPickupPeople ? 'Pick-up People' : 'Confirm Pick-up People'
          }
          buttonText='Add a new pick-up person'
          buttonRoute='/pickup_people/new'
          subheaderText={
            validPickupPeople
              ? null
              : `To confirm or update pick-up people for ${season.year}, click the "confirm" or "remove" button for each person listed below.`
          }
          account={account}
          setModal={setModal}
          reupRequired={reupRequired}
          editable
        />
      )}

      {<Preferences account={account} />}
      {reupRequired && <RegisterButton account={account} />}
    </>
  )
}

export default Overview
